export default {
  ru: {
    cameraPending: 'Проверка оборудования.<br>Пожалуйста, подождите ...',
    printPending: 'Идёт печать.<br>Пожалуйста, подождите ...',
    processing: 'Идет обработка.<br>Пожалуйста, подождите ...',
    take: 'Сфотографировать',
    cancel: 'Отменить',
    print: 'Распечатать',
    reshoot: 'Переснять',
    send: 'Отправить на email',
    submit: 'Отправить',
    pick: 'Выбрать',
    selectFrame: 'Выбрать рамку',
    removeFrame: 'Удалить рамку',
    pickUp: 'Готово, заберите ваше фото',
    goHome: 'На главную',
    goBack: 'Вернуться к фото',
    badHardware: 'Ошибка отправки',
    notPossible: 'По техническим причинам отправка невозможна',
    printError: 'Ошибка оборудования',
    printNotPossible: 'Устройство временно недоступно',
    emailSuccess: 'Фото было отправлено на адрес',
    emailSubject: 'Ваше фото',
  },
  en: {
    // en
  },
};
